import { render } from "./AlertsModal.vue?vue&type=template&id=34c158f4"
import script from "./AlertsModal.vue?vue&type=script&lang=js"
export * from "./AlertsModal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/antoniokatarov/PhpstormProjects/WEBIS WHS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__